$(function() {
    $(document).on('click', '.js-scroll-to', function() {
        let target = $(this).data('anchor');

        if ( $(target).length <= 0 ) {
            target = '.js-scroll-target:not(.hidden)';
        }

        $('html, body').animate({
            scrollTop: $(target).offset().top - $('.js-header').outerHeight(),

            duration: 400
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/anchors.js